import { Graphics } from 'pixi.js'
import { assertBeat } from './Beat'

// Placeholder beat: a few plain shapes sweep, spin and pulse for 2 s. Stands
// in for the reveal beat (item C) so the logger, trace capture, file sizes and
// memory can be proven now. Its numbers do not count toward Gate 1.

const DURATION_MS = 2000
const SHAPES = 6

export function createPlaceholderBeat(stage) {
    const { world, size } = stage
    const shapes = []
    for (let i = 0; i < SHAPES; i++) {
        const g = new Graphics()
        if (i % 2 === 0) g.circle(0, 0, 26).fill(0xe0a030)
        else g.poly([-30, 0, -15, -26, 15, -26, 30, 0, 15, 26, -15, 26]).fill(0x4fa3d8)
        world.addChild(g)
        shapes.push(g)
    }
    let t0 = 0

    // Idle pose: parked off screen but still rendered, so the GPU geometry is
    // built before a run (a first-render upload inside a run is an 80 ms stall).
    function park() {
        for (let i = 0; i < SHAPES; i++) {
            shapes[i].x = -1000
            shapes[i].y = -1000
        }
    }
    park()

    const beat = {
        name: 'placeholder-v1',
        durationMs: DURATION_MS,
        start(now) {
            t0 = now
            this.step(now)
        },
        step(now) {
            const p = Math.min(1, (now - t0) / DURATION_MS)
            const w = size.width, h = size.height
            for (let i = 0; i < SHAPES; i++) {
                const g = shapes[i]
                const lane = (i + 0.5) / SHAPES
                g.x = w * (0.1 + 0.8 * p)
                g.y = h * lane + Math.sin(p * Math.PI * 4 + i) * h * 0.05
                g.rotation = p * Math.PI * 2 * (i % 2 ? -1 : 1)
                g.scale.set(0.8 + 0.4 * Math.sin(p * Math.PI))
                g.alpha = 0.6 + 0.4 * Math.sin(p * Math.PI)
            }
            return p >= 1
        },
        reset() {
            park()
        },
        destroy() {
            for (const g of shapes) g.destroy()
        },
    }
    return assertBeat(beat)
}
